import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { Pagination, useIsPaginationVisible } from './Pagination';

const Root = styled(Stack, { name: 'Footer', slot: 'Root' })(({ theme }) => ({
  position: 'sticky',
  left: 0,
  bottom: 0,
  zIndex: 10,
  marginTop: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
}));

const useIsFooterVisible = () => {
  const isPaginationVisible = useIsPaginationVisible();
  return isPaginationVisible;
};

export const Footer = () => {
  const isVisible = useIsFooterVisible();

  if (!isVisible) {
    return null;
  }

  return (
    <Root
      direction="row"
      alignItems="center"
      sx={{ gap: 1 }}
      className="Table-footer"
    >
      <div style={{ flex: 1 }} />
      <Pagination />
    </Root>
  );
};
